import { Platform } from "quasar";
import { getAccountID } from "src/utils/commonFunction";

const routes = [
  {
    path: "/",
    component: () => import("layouts/Main/Index.vue"),
    children: [
      {
        path: "",
        name: "Home",
        component: () => {
          return import("pages/HopePageWrapper.vue");
          // if (getAccountID()) return import("pages/StoreDetail.vue");
          // return Platform?.is?.mobile
          //   ? import("pages/IndexPage.vue")
          //   : import("pages/web/Dashboard.vue");
        },
        meta: {
          header: {
            showHeader: true,
            homePageHeader: true,
            showPoints: true,
            showAvatar: true,
            showBack: false,
            Title: "Loyal-N-Save",
          },
          clearHistory: true,
        },
      },
      {
        path: "/store",
        name: "Store",
        component: () => import("pages/Store.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "My Stores",
            showsearch: true,
          },
        },
      },
      {
        path: "/find-store",
        name: "FindStore",
        component: () => import("pages/FindStore.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Find Stores",
          },
        },
      },
      {
        path: "/store-detail/:storeid",
        name: "StoreDetail",
        component: () => import("pages/StoreDetail.vue"),
        meta: {
          header: {
            account: {
              homePageHeader: true,
              showHeader: true,
              showPoints: true,
              showAvatar: true,
              showBack: false,
              Title: "",
            },
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Store Detail",
          },
        },
      },
      {
        path: "/store-detail/:storeid/my-team",
        name: "MyTeam",
        component: () => import("pages/MyTeam.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "My Team",
          },
        },
      },
      {
        path: "/store-detail/:storeid/my-team/my-team-user/:friendid",
        name: "MyTeamUser",
        component: () => import("pages/MyTeamUser.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "My Team User",
          },
        },
      },
      {
        path: "/store-detail/:storeid/my-team/my-team-level/:friendid",
        name: "MyTeamLevel",
        component: () => import("pages/MyTeamLevel.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "My Team Level",
          },
        },
      },
      {
        path: "/store-detail/:storeid/store-deal",
        name: "FilterByCampaignGroupDeal",
        component: () => import("pages/MyDeal.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Deals",
          },
        },
      },
      {
        path: "/store-detail/:storeid/my-deal",
        name: "MyDeal",
        component: () => import("pages/StoreDealWith21Offers.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Store Deals",
          },
        },
      },
      {
        path: "/store-detail/:id/offers",
        name: "Offers",
        component: () => import("pages/StoreDetailOffers.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "21+ OFFERS",
          },
        },
      },
      {
        path: "/store-detail/:dealid/deal-detail/:type",
        name: "DealDetail",
        component: () => import("pages/DealDetail.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Deal Detail",
          },
        },
        props: true,
      },
      {
        path: "/store-detail/:storeid/online-discount/:discountid",
        name: "OnlineDiscountDetail",
        component: () => import("pages/OnlineDiscountDetail.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Discount Detail",
          },
        },
        props: true,
      },
      {
        path: "/store-detail/:storeid/online-discount/:discountid/locations",
        name: "OnlineDiscountLocations",
        component: () => import("pages/OnlineDiscountLocations.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Store Locations",
          },
        },
        props: true,
      },
      {
        path: "/store-detail/:storeid/store-locator",
        name: "StoreLocator",
        component: () => import("pages/StoreLocator.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Store Location",
          },
        },
      },
      {
        path: "/store-detail/:storeid/store-feedback",
        name: "StoreFeedback",
        component: () => import("pages/StoreFeedback.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Store Feedback",
          },
        },
      },
      {
        path: "/store-detail/:storeid/my-coupons",
        name: "MyCoupons",
        component: () => import("pages/MyCoupons.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "My Coupons",
          },
        },
      },
      {
        path: "/my-deals",
        name: "MyDeals",
        component: () => import("pages/MyDeals.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "My Deals",
            showsearch: false,
          },
        },
      },
      {
        path: "/my-mfg",
        name: "MyMFGs",
        component: () => import("pages/MyMfg.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "My MFGs",
            showsearch: true,
          },
        },
      },
      {
        path: "/find-mfg",
        name: "FindMfg",
        component: () => import("pages/FindMfg.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Find MFG",
            showsearch: true,
          },
        },
      },
      {
        path: "/mfg-detail/:manufacturerid/:from",
        name: "MyMFGDetail",
        component: () => import("pages/MyMfgDetail.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "MFGs Detail",
          },
        },
      },
      {
        path: "/my-profile",
        name: "MyProfile",
        component: () => import("pages/MyProfile.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "My Profile",
          },
        },
      },
      {
        path: "/edit-profile",
        name: "EditProfile",
        component: () => import("pages/EditProfile.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
          },
        },
      },
      {
        path: "/leaderboard",
        name: "LeaderBoard",
        component: () => import("pages/LeaderBoard.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Leaderboard",
          },
        },
      },
      {
        path: "/points-breakdown",
        name: "PointsBreakdown",
        component: () => import("pages/PointsBreakdown.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Points Breakdown",
          },
        },
      },
      {
        path: "/points-breakdown-detail/:storeid/:type",
        name: "PointsBreakdownDetail",
        component: () => import("pages/PointsBreakdownDetail.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Points Breakdown Detail",
          },
        },
      },
      {
        path: "/faq",
        name: "Faq",
        component: () => import("pages/Faq.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "FAQ",
          },
        },
      },
      {
        path: "/notifications",
        name: "Notifications",
        component: () => import("pages/Notifications.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Notifications",
          },
        },
      },
      {
        path: "/template",
        name: "Template",
        component: () => import("pages/Template.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Template",
          },
        },
      },
      {
        path: "/swag-shop",
        name: "SwagShop",
        component: () => import("pages/SwagShop.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Swag Shop",
            showFilter: true,
          },
        },
      },
      {
        path: "/swag-shop/products",
        name: "SwagShopList",
        component: () => import("pages/SwagShopList.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Products",
            showFilter: true,
          },
        },
      },
      {
        path: "/swag-shop/products/:id",
        name: "SwagShopDetail",
        component: () =>
          Platform.is.mobile
            ? import("pages/SwagShopDetail.vue")
            : import("pages/web/SwagShopDetail.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "",
          },
        },
      },
      {
        path: "/swag-shop/products/:id/confirm-purchase",
        name: "ConfirmPurchase",
        component: () => import("pages/ConfirmPurchase.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Confirm Purchase",
          },
        },
      },
      {
        path: "/gifts",
        name: "Gifts",
        component: () => import("pages/Gifts.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Gifts",
            showsearch: true,
          },
        },
      },
      {
        path: "/gifts/:giftId",
        name: "GiftsDetail",
        component: () => import("pages/Gifts-Detail.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Gift Detail",
          },
        },
      },
      {
        path: "swag-shop/purchase-history",
        name: "History",
        component: () => import("pages/swag-shop/History.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Purchase History",
            showsearch: false,
          },
        },
      },
      {
        path: "swag-shop/purchase-history/:id",
        name: "HistoryDetail",
        component: () => import("pages/swag-shop/History-Detail.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Purchase",
            showsearch: false,
          },
        },
      },
      {
        path: "/swag-shop/shipping-addresses",
        name: "ShippingAddress",
        component: () => import("pages/swag-shop/ShippingAddress.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Select Address",
          },
        },
      },
      {
        path: "/friend-list",
        name: "FriendList",
        component: () => import("pages/swag-shop/FriendList.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            showsearch: false,
            Title: "Select A Friend",
          },
        },
      },
      {
        path: "/question",
        name: "Question",
        component: () => import("pages/swag-shop/Question.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Question",
          },
        },
      },
      {
        path: "/friend/:id",
        name: "FriendDetail",
        component: () => import("pages/FriendDetails.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Friend Detail",
          },
        },
      },
      {
        path: "/feedback",
        name: "Feedback",
        component: () => import("pages/Feedback.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Feedback",
          },
        },
      },
      {
        path: "/messages",
        name: "Messages",
        component: () =>
          Platform.is.mobile
            ? import("pages/Messages.vue")
            : import("pages/web/Messages.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Messages",
            showsearch: true,
          },
        },
      },
      /* {
        path: "/password-settings",
        name: "PasswordSettings",
        component: () => import("pages/PasswordSettings.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Change Password",
          },
        },
      }, */
      {
        path: "/chat/:msgId",
        name: "Chat",
        component: () => import("pages/Chat.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Chat",
          },
        },
      },
      {
        path: "/chat-setting/:msgId",
        name: "ChatSetting",
        component: () => import("pages/ChatSetting.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Chat Setting",
          },
        },
      },
      {
        path: "/more",
        name: "More",
        component: () => import("pages/More.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "More",
          },
        },
      },
      {
        path: "/all-requests",
        name: "AllRequests",
        component: () => import("pages/AllRequests.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "All Requests",
            showsearch: true,
          },
        },
      },
      {
        path: "/completed-deals",
        name: "CompletedDeals",
        component: () => import("pages/CompletedDeals.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Completed Deals",
          },
        },
      },
      {
        path: "/receipts",
        name: "Receipts",
        component: () => import("pages/Receipts.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Receipts",
          },
        },
      },
      {
        path: "/receipts-detail/:id",
        name: "ReceiptsDetail",
        component: () => import("pages/ReceiptsDetail.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Receipts Detail",
          },
        },
      },
      {
        path: "/shipping-addresses",
        name: "ShippingAddresses",
        component: () => import("pages/ShippingAddresses.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Shipping Addresses",
          },
        },
      },
      {
        path: "/loyalty-cards",
        name: "LoyaltyCards",
        component: () => import("pages/LoyaltyCards.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Loyalty Cards",
          },
        },
      },
      {
        path: "/settings",
        name: "Settings",
        component: () => import("pages/Settings.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Settings",
          },
        },
      },
      {
        path: "/user-settings",
        name: "UserSettings",
        component: () => import("pages/UserSettings.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "User Settings",
          },
        },
      },
      {
        path: "/store-settings",
        name: "StoreSettings",
        component: () => import("pages/StoreSettings.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Store Settings",
            showsearch: true,
          },
        },
      },
      {
        path: "/blocked-users",
        name: "BlockedUsers",
        component: () => import("pages/BlockedUsers.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Blocked Users",
            showsearch: true,
          },
        },
      },
      {
        path: "/delete-account",
        name: "DeleteAccount",
        component: () => import("pages/DeleteAccount.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Delete Account",
          },
        },
      },
      {
        path: "/delete-your-account",
        name: "DeleteYourAccount",
        component: () => import("pages/DeleteYourAccount.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Delete Your Account",
          },
        },
      },
      {
        path: "/add-friends",
        name: "AddFriends",
        component: () => import("pages/AddFriends.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Add Friends",
          },
        },
      },
      {
        path: "globalsearch",
        name: "GlobalSearch",
        component: () => import("pages/GlobalSearch.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            Title: "",
            showBack: true,
          },
        },
      },
      {
        path: "/store-detail/:storeid/review-detail/:reviewid",
        name: "ReviewDetail",
        component: () => import("pages/ReviewDetail.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            Title: "Review Detail",
            showBack: true,
          },
        },
      },
      {
        path: "/coupons",
        name: "Coupons",
        component: () => import("pages/Coupons.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "My Coupons",
          },
        },
      },
      {
        path: "/contact-us",
        name: "ContactUs",
        component: () => import("pages/ContactUs.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: true,
            Title: "Contact Us",
          },
        },
      },
      {
        path: "/notificationredirection",
        name: "HandlePushNotificationPWA",
        component: () => import("pages/HandlePushNotificationPWA.vue"),
        meta: {
          header: {
            homePageHeader: false,
            showHeader: false,
            showPoints: false,
            showAvatar: false,
            showBack: false,
            Title: "Handle Push Notification PWA",
          },
        },
      },
    ],
  },

  // Account
  {
    path: "/login",
    component: () => import("layouts/Main/Account.vue"),
    children: [
      {
        path: "",
        name: "NewLogin",
        component: () => import("pages/account/index.vue"),
        meta: {
          showWithoutLogin: true,
        },
      },
      {
        path: "/account-link",
        name: "AccountLinked",
        component: () => import("pages/account/account-linked.vue"),
        meta: {
          showWithoutLogin: true,
        },
      },
      {
        path: "/n/account-link",
        name: "AccountLinked",
        component: () => import("pages/account/account-linked.vue"),
        meta: {
          showWithoutLogin: true,
        },
      },
    ],
  },
  {
    path: "/callback",
    name: "Callback",
    component: () => import("pages/OidcCallback.vue"),
  },
  ,
  {
    path: "/ageverification",
    name: "AgeVerification",
    component: () => import("pages/AgeVerified.vue"),
  },
  {
    path: "/silent-renew",
    name: "SilentRenew",
    component: () => import("pages/SilentRenew.vue"),
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/:catchAll(.*)*",
    component: () => import("pages/ErrorNotFound.vue"),
  },
  // No Network Page
  {
    path: "/no-network",
    name: "NoNetwork",
    component: () => import("pages/NoNetwork.vue"),
    meta: {
      showWithoutLogin: true,
    },
  },
  {
    path: "/unsubscribe-from-mail/:email/",
    component: () => import("layouts/Main/Unsubscribe.vue"),
    children: [
      {
        path: "",
        name: "unsubscribe-from-mail",
        component: () => import("pages/unsubscribe/index.vue"),
        meta: {
          showWithoutLogin: true,
        },
      },
    ],
  },
];

export default routes;
